import { render, staticRenderFns } from "./basicForm.vue?vue&type=template&id=e92ce03a&scoped=true&"
import script from "./basicForm.vue?vue&type=script&lang=js&"
export * from "./basicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92ce03a",
  null
  
)

export default component.exports